// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Check from '@material-ui/icons/Check';
import Wrong from '@material-ui/icons/Cancel';

import SnackMessages from './core/SnackMessages';
import LoginLogo from './images/loginLogo.png';


import * as coreSelectors from './core/selectors';
import * as coreActions from './core/actions';

const styles = theme => ({
  root : {
    backgroundImage: theme.brandingColors.loginGradient,    
    backgroundColor: theme.palette.secondary.main,
    position : 'fixed',
    top: 0, 
    bottom: 0,
    right: 0,
    left: 0, 
  },
  dialog : {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 25,
    color: theme.palette.primary.contrastText,
    padding: 25,
    width: 400,
  },
  passwordField : {
    padding: 5,
    color: theme.palette.primary.contrastText,
    ...theme.typography.h6,
  },
  passwordFieldInput : {
    color: theme.palette.primary.contrastText,
    borderBottom: '2px solid white',
  },
  passwordFieldLabel : {
    color: theme.palette.primary.contrastText,
    '&.Mui-focused' : {
      color: theme.palette.primary.contrastText,
    },
  },
  checkLine : {
    ...theme.typography.body1,
  },
  subCheckLine : {
    ...theme.typography.body1,
    marginLeft: 40,
  },
  checkIcon : {
    verticalAlign: 'text-bottom',
  },
  /* Reverse color text field */
  reverseTextField : {
    color: 'white',
    '& input' : {
      color: 'white !important',
    },
    '& label' : {
      color: 'white !important',
    },
    '& fieldset' : {
      borderColor: 'white !important',
      borderWidth: 2,
    }
  }
});


/*
 * Screen displayed before credentials have been established
 */

class PasswordChangeScreen extends Component {
  specials = ['@', '#', '$', '%', '^', '&', '*', '-', '_', '!', '+', '=',
              '[',']', '{', '}', "'", '|', '\\', ':', ',', '.', '?', '/',
              '`', '~', '"', '(', ')', ';' ];
  
  state = {
    eightSixteen : false,
    characterGroups : false,
    upperGroup : false,
    lowerGroup : false,
    numberGroup : false,
    specialGroup : false,
    repeatMatch : false,
    changeEnabled : false,
    password: '',
    repeatPassword: '',
    changingPassword : false,
  }

  checkMark(which) {
    if (which) {
      return(<Check className={this.props.classes.checkIcon}/>);
    } else {
      return(<Wrong className={this.props.classes.checkIcon}/>);
    }
  }

  checkChange = (password, repeatPassword) => {
    let eightSixteen  = password.length >= 8 && password.length <= 16;
    let upperGroup = password.match(/[A-Z]/);
    let lowerGroup = password.match(/[a-z]/);
    let numberGroup = password.match(/[0-9]/);
    let specialGroup = this.specials.some(c => password.includes(c));
    let count = (upperGroup ? 1 : 0) + (lowerGroup ? 1 : 0) +
                (numberGroup ? 1 : 0) + (specialGroup ? 1 : 0);
    let characterGroups = count >= 3;
    let repeatMatch = password === repeatPassword;
    let changeEnabled = eightSixteen && characterGroups && repeatMatch;

    this.setState({password, repeatPassword, eightSixteen, upperGroup,
                   repeatMatch, lowerGroup, numberGroup,
                   specialGroup, characterGroups, changeEnabled });
  }
  
  filterChars = (value) => {
    return(value.split('')
                .filter(c => c.match(/[A-Za-z0-9]/) || this.specials.some(s => c === s))
                .join(''));
  }
  
  passwordChanged = (value) => {
    this.checkChange(this.filterChars(value), this.state.repeatPassword);
  }
  
  repeatPasswordChanged = (value) => {
    this.checkChange(this.state.password, this.filterChars(value));
  }

  changePassword = () => {
    this.setState({changingPassword: true});    
    this.props.changePassword(this.state.password, () => {
      this.setState({changingPassword: false});
      if (this.props.manualPasswordChange) {
        this.props.setManualPasswordChange(false);
      }
    });
  }

  render() {
    // eslint-disable-next-line
    const { user, classes, setManualPasswordChange } = this.props;

    return (
      <React.Fragment>
        <MuiCore.Grid container className={classes.root}
                      direction = 'column'
                      justify = 'center'
                      alignItems = 'center'>
          <MuiCore.Grid item className={classes.dialog}>
            <MuiCore.Grid container spacing={1}>
              <MuiCore.Grid item xs={12} style={{ textAlign: 'center'}}>
                <img alt=''
                     src={LoginLogo}/>
              </MuiCore.Grid>

              <MuiCore.Grid item xs={12}>
                <MuiCore.Typography style={{ textAlign: 'center'}}
                                    variant='h6'>Choose a new password.</MuiCore.Typography>
              </MuiCore.Grid>
              
              <MuiCore.Grid item xs={12}>
                <MuiCore.Grid container direction = 'column'>
                  <MuiCore.Grid item className={classes.checkLine}>
                    {this.checkMark(this.state.eightSixteen)} Between 8 and 16 characters
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.checkLine}>
                    {this.checkMark(this.state.characterGroups)} Three of these:
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.subCheckLine}>
                    {this.checkMark(this.state.upperGroup)} Upper case letters
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.subCheckLine}>
                    {this.checkMark(this.state.lowerGroup)} Lower case letters
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.subCheckLine}>
                    {this.checkMark(this.state.numberGroup)} Numbers
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.subCheckLine}>
                    {this.checkMark(this.state.specialGroup)} Special: {this.specials.join('')}
                  </MuiCore.Grid>
                  <MuiCore.Grid item className={classes.checkLine}>
                    {this.checkMark(this.state.repeatMatch)} Repeat password matches
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
              
              <MuiCore.Grid item xs={12} style={{paddingTop: 15}}>
                <MuiCore.Typography variant='body1'>Password</MuiCore.Typography>
                <MuiCore.TextField value={this.state.password}
                                   InputLabelProps={{ shrink: true}}
                                   className={classes.reverseTextField}
                                   autoFocus={true}
                                   fullWidth
                                   onChange={(event) => this.passwordChanged(event.target.value)}
                                   type='password'/>
              </MuiCore.Grid>
              <MuiCore.Grid item xs={12}>
                <MuiCore.Typography variant='body1'>Repeat Password</MuiCore.Typography>
                <MuiCore.TextField value={this.state.repeatPassword}
                                   fullWidth
                                   InputLabelProps={{ shrink: true}}                
                                   className={classes.reverseTextField}
                                   onChange={(event) => this.repeatPasswordChanged(event.target.value)}
                                   label='Repeat Password' type='password'/>
              </MuiCore.Grid>
              
              <MuiCore.Grid style={{paddingTop : 40}} item xs={12}>
                <MuiCore.Grid container spacing={1} justify='center'>
                  <MuiCore.Grid item>
                    <MuiCore.Button onClick={this.changePassword}
                                    disabled={!this.state.changeEnabled || this.state.changingPassword}>
                      {this.state.changingPassword ? 'Changing...' : 'Change Password'}
                    </MuiCore.Button>
                  </MuiCore.Grid>
                  <MuiCore.Hidden xlDown={user.temporaryPassword === 'Y'}>
                    <MuiCore.Grid item>
                      <MuiCore.Button disabled={this.state.changingPassword}
                                      onClick={() => setManualPasswordChange(false)}
                                      variant='text'>
                        Cancel
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </MuiCore.Hidden>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
        </MuiCore.Grid>            
        <SnackMessages/>
      </React.Fragment>);
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    manualPasswordChange : coreSelectors.getManualPasswordChange(state),
  });
};

const mapDispatchToProps = {
  postSnackMessage : coreActions.postSnackMessage,
  changePassword: coreActions.changePassword,
  setManualPasswordChange : coreActions.setManualPasswordChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PasswordChangeScreen));

